module.exports = __webpack_public_path__ + "static/img/1.35ce88a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/people/mikse/1.jpg
// module id = q3OS
// module chunks = 0